import { combineReducers } from 'redux';
import account from './user/reducer';
import route from './route/reducer';
export default combineReducers({
  account,
  route
});